/* global gapi */

import React, { Component } from "react";
import BigCalendar from "react-big-calendar";
import moment from "moment";

import "react-big-calendar/lib/css/react-big-calendar.css";
import 'moment/locale/fr';
moment.locale('fr');

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment));

class Calendar extends Component {

  // handleSelect = ({ start, end }) => {
  //   const title = window.prompt('New Event name')
  //   if (title)
  //     this.setState({
  //       events: [
  //         ...this.state.events,
  //         {
  //           start,
  //           end,
  //           title,
  //         },
  //       ],
  //     })
  // }

    constructor(props) {
        super(props);
        this.getEvents = this.getEvents.bind(this);

        this.state = {
            GOOGLE_API_KEY: "AIzaSyCFTi7xiicVhc82SKrGbU2DFuAAz-JLP4A",
            CALENDAR_ID: "shdj70i4s9f38buigl4tjtj7f8@group.calendar.google.com",
        }
    }

    componentDidMount = () => {
        //this.getEvents();
    };

    getEvents() {
        let that = this;
        function start() {
            gapi.client
                .init({
                    apiKey: that.state.GOOGLE_API_KEY
                })
                .then(function() {
                    return gapi.client.request({
                        path: `https://www.googleapis.com/calendar/v3/calendars/${that.state.CALENDAR_ID}/events?maxResults=11&orderBy=updated&timeMin=${moment().toISOString()}&timeMax=${moment()
                            .endOf("day")
                            .toISOString()}`
                    });
                })
                .then(
                    response => {
                        let events = response.result.items;
                        /*let sortedEvents = events.sort(function(a, b) {
                            return (
                                moment(b.start.dateTime).format("YYYYMMDD") -
                                moment(a.start.dateTime).format("YYYYMMDD")
                            );
                        });*/
                        if (events.length > 0) {

                        } else {

                        }
                    },
                    function(err) {
                        console.log(err);
                    }
                );
        }
        gapi.load("client", start);
    }

  handleSelectEvent(e, history) {
    //history.replace('/audits/' + e.id)
      window.open('/#/audits/' + e.id, '_blank');
  }

  render() {
    return (
      <div>
        <BigCalendar
          selectable
          popup
          defaultDate={new Date()}
          defaultView="month"
          events={this.props.events}
          style={{ height: 1000, maxHeight: '80vh' }}
          onSelectEvent={e => this.handleSelectEvent(e, this.props.history)}
          eventPropGetter={event => ({
              style: {
                  backgroundColor: event.color,
              },
          })}
          messages={{
              month: 'Mois',
              week: 'Semaine',
              day: 'Jour',
              agenda: 'Agenda',
              today: 'Aujourd\'hui',
              previous: 'retour',
              next: 'suivant',
          }}
          //onSelectSlot={this.handleSelect}
        />
      </div>
    );
  }
}

export default Calendar;



// WEBPACK FOOTER //
// ./src/component/utils/Calendar.js